module.exports = __webpack_public_path__ + "static/media/pesto.037a92e0.jpg";